class ScrollToTop {
    _btn: HTMLButtonElement;
    _resizeObserver: ResizeObserver;

    constructor() {
        this._btn = document.createElement( 'button' );
        this._btn.type = 'button';
        this._btn.className = 'scrolltotop__btn scrolltotop__btn--hidden';
        this._btn.style.opacity = '0';
        this._btn.addEventListener( 'click', this._onClick.bind( this ) );

        document.body.appendChild( this._btn );

        this._resizeObserver = new ResizeObserver( this._onResize.bind( this ) );
        this._resizeObserver.observe( document.body );

        document.addEventListener( 'scroll', this._onScroll.bind( this ), { passive: true } );

        this._test();
    }

    _onScroll( event: Event ): void {
        this._test();
    }

    _onResize( entries: ResizeObserverEntry[], observer: ResizeObserver ): void {
        this._test();
    }

    _test(): void {
        if ( !document.body ) {
            return;
        }

        const r = document.body.getBoundingClientRect();

        const scrollPercentage = Math.floor( ( ( r.top * -1 ) / ( r.height - window.innerHeight ) ) * 100 );

        if ( scrollPercentage < this._threshold ) {
            this._btn.style.opacity = '0';
            this._btn.classList.add( 'scrolltotop__btn--hidden' );
            return;
        }

        this._btn.classList.remove( 'scrolltotop__btn--hidden' );
        this._btn.style.opacity = '1';

        const footer = document.querySelector<HTMLElement>( '.main-footer' );

        if ( !footer ) {
            return;
        }

        const footerRect = footer.getBoundingClientRect();

        const btnRect = this._btn.getBoundingClientRect();

        if ( ( btnRect.bottom - ( btnRect.height / 2 ) ) >= Math.ceil( footerRect.top ) ) {
            this._btn.classList.add( 'scrolltotop__btn--light' );
        } else {
            this._btn.classList.remove( 'scrolltotop__btn--light' );
        }
    }

    _onClick( event: Event ): void {
        this._btn.blur();
        this._btn.classList.add( 'scrolltotop__btn--hidden' );
        this._btn.style.opacity = '0';

        window.scrollTo( {
            top: 0,
            behavior: 'smooth',
        } );
    }

    get _threshold() {
        if ( window.innerWidth < 576 ) {
            return 20;
        }
        return 33;
    }
}

export default function initScrollToTop(): void {
    if ( document.body && document.body.classList.contains( 'scrolltotop' ) ) {
        new ScrollToTop();
    }
}
